import { i18nLangs } from "../../../data/static-data"

export const getLocationUnitLangPostfix = (language) => {
    if(language === i18nLangs.RU) {
        return 'ru'
    }
    if(language === i18nLangs.TR) {
        return 'tr'
    }

    return 'ru'
}

export const getEventsAddressPostfix = (language) =>{ 
    if(language === i18nLangs.RU) {
        return 'ru'
    }
    if(language === i18nLangs.TR) {
        return 'tr'
    }
    if(language === i18nLangs.EN) {
        return 'tr'
    }

    return 'ru'
}